exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-wrap[data-v-9ede7a9c]{display:inline-flex;flex-direction:column;gap:2px;flex-shrink:0;min-width:120px}.ds-lbl[data-v-9ede7a9c]{font-family:Poppins,sans-serif;font-size:10px;font-weight:600;color:#7e8b97;text-transform:uppercase;letter-spacing:.06em;white-space:nowrap;line-height:1}.ds-lbl b[data-v-9ede7a9c]{color:#12283f;font-weight:700}.ds-slider[data-v-9ede7a9c]{-webkit-appearance:none;width:100%;height:4px;border-radius:2px;background:#e2e5ea;outline:none;cursor:pointer;accent-color:#12283f}", ""]);

// exports
